import styled from "styled-components";

export const IncompleteDepositStyled = styled.div`
    padding: 12px;
    border-radius: 16px;
    background: var(--color-fill-secondary);
    display: flex;
    flex-direction: column;
    gap: 12px;
    
    .incomplete-deposit-badge {
        padding: 2px 8px 4px 8px;
        border-radius: 12px;
        background: var(--gradient-yellow-red);
        color: var(--color-label-primary-inverted);
    }
    
    .incomplete-deposit-content {
        display: flex;
        gap: 12px;
        align-items: center;
    }
`;